<template>
  <b-container class="sectionDiv" fluid>
    <b-row>
      <b-col><h4>{{sectionData.title}}</h4></b-col>
    </b-row>

    <b-row v-for="(vardata,idx) in sectionData.variables" :key="idx">
      <b-col><VariableComponent :variable-data="vardata"/></b-col>
    </b-row>

  </b-container>
</template>

<script>
// import {mapGetters, mapState} from "vuex";

import VariableComponent from "@/views/interview/VariableComponent";
export default {
  name: 'SectionComponent',

  props: {
    sectionData: Object
  },

  components: {
    VariableComponent
    // Widget, ViewPathWidget
  },

  // computed: {
  //   ...mapState(['activeSurvey', 'absoluteDrillPath']),
  //   ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),
  //
  // },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.sectionDiv {
  background-color: #d0cece;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-bottom: 1em;
}

</style>
